module.exports = __webpack_public_path__ + "img/gpay.78161812.png";